import { useMediaQuery, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { DashboardGraph } from './dashboard-grarph'
import { ItemsStatistic } from './items-statistic'
import { SectionWrapper } from './section-wrapper'
import { CountriesViews } from './countries-views'
import { TopItemsStatisticWrapper } from './top-items-statistic'

export const AccountDashboard = () => {
  const [t] = useTranslation()
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('laptop'))

  return (
    <div>
      {isDesktop && <ItemsStatistic />}
      <SectionWrapper title={t('dashboard-total-views-title.v')}>
        <DashboardGraph />
      </SectionWrapper>
      <TopItemsStatisticWrapper />
      <CountriesViews />
    </div>
  )
}
